import GenericTable from '../../../../../cars/components/V3/_shared/GenericTable/GenericTable'
import { TableMobileCardContent } from '../../../../../cars/components/V3/_shared/GenericTable/TableMobileCardContent'
import { useUserContext } from '../../../../../../context/UserProvider'
import { formatCurrency } from '../../../utils/formatCurrency'
import { useNavigate } from 'react-router-dom'
import tollReportTableColumns from './tollReportColumns'
import type { Toll } from '../../../../../../types'
import type { Row } from '@tanstack/react-table'
import { formatNumber } from '../../../utils/formatNumber'
import { mapMonth } from '../../../utils/mapMonth'

type TollReportTableProps = {
  data: any
  isLoading?: boolean
}

function TollReportTable({ data, isLoading }: TollReportTableProps) {
  // @ts-ignore  remove this ts-ignore when UserContext is type safe
  const { chosenCompany, handleSetConsolidateInvoice } = useUserContext()
  const columns = tollReportTableColumns({ chosenCompany, handleSetConsolidateInvoice })

  return (
    <GenericTable
      className="max-h-[50vh]"
      data={data}
      isLoading={isLoading}
      columns={columns}
      mobileCardContent={(row) => {
        return <MobileCardContent row={row} handleSetConsolidateInvoice={handleSetConsolidateInvoice} />
      }}
    />
  )
}

export default TollReportTable

function MobileCardContent({
  row,
  handleSetConsolidateInvoice,
}: {
  row: Row<Toll>
  handleSetConsolidateInvoice: (value: string) => void
}) {
  const navigate = useNavigate()

  const header = `${mapMonth(row.original.tMonth)} ${row.original.tYear}`
  const data = [
    {
      label: 'Samlefakturakode',
      value: row.original.consolidatedInvoiceAgreement,
    },
    {
      label: 'Beløp',
      value: formatCurrency(row.original.amountIncVat),
    },
    {
      label: 'Antall passeringer',
      value: formatNumber(row.original.antallPasseringer),
    },
  ]

  const action = {
    onClick: () => {
      handleSetConsolidateInvoice(row.original.consolidatedInvoiceAgreement)
      navigate(
        `/reports/toll/${row.original.tYear}-${row.original.tMonth}?consolidatedAgreementID=${row.original.consolidatedInvoiceAgreement}`,
      )
    },
  }

  return <TableMobileCardContent header={header} data={data} action={action} />
}
